<template>
  <div>
    <TopBarMember class="mb-0 mb-sm-3" />
    <b-container class="px-0 px-sm-3">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        body-class="px-2"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <h5>
          <i class="fas fa-thumbs-up"></i> แนะนำเพื่อน
        </h5>
        <b-row class="mx-0 px-0">
          <b-col class="mt-0 mb-1 py-1 px-1" cols="3" lg="3" xl="3" md="3" sm="3">
            <router-link
              :class="(page == 'overview' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0'"
              to="/member/affiliate/overview"
            >
              <i class="far fa-handshake"></i>
              <br />ภาพรวม
            </router-link>
          </b-col>
          <b-col class="mt-0 mb-1 py-1 px-1" cols="3" lg="3" xl="3" md="3" sm="3">
            <router-link
              :class="(page == 'members' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0'"
              to="/member/affiliate/members"
            >
              <i class="fas fa-chalkboard-teacher"></i>
              <br />ที่สมัคร
            </router-link>
          </b-col>
          <b-col class="mt-0 mb-1 py-1 px-1" cols="3" lg="3" xl="3" md="3" sm="3">
            <router-link
              :class="(page == 'revenue' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0'"
              to="/member/affiliate/revenue"
            >
              <i class="fas fa-money-check-alt"></i>
              <br />รายได้
            </router-link>
          </b-col>
          <b-col class="mt-0 mb-1 py-1 px-1" cols="3" lg="3" xl="3" md="3" sm="3">
            <router-link
              :class="(page == 'withdraw' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0'"
              to="/member/affiliate/withdraw"
            >
              <i class="fas fa-hand-holding-usd"></i>
              <br />ถอนรายได้
            </router-link>
          </b-col>
        </b-row>
        <div class="w-100 my-2 border-bottom"></div>
        <Overview v-if="page == 'overview'" />
        <Members v-if="page == 'members'" />
        <Revenue v-if="page == 'revenue'" />
        <Withdraw v-if="page == 'withdraw'" />
      </b-card>
    </b-container>
    <FooterIndex class="mt-2" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";

// Include Component
import Overview from "@/components/member/affiliate/Overview.vue";
import Members from "@/components/member/affiliate/Members.vue";
import Revenue from "@/components/member/affiliate/Revenue.vue";
import Withdraw from "@/components/member/affiliate/Withdraw.vue";
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: 'Affiliate',
  components: {
    TopBarMember,
    Overview,
    Members,
    Revenue,
    Withdraw,
    FooterIndex
  },
  props: ['page']
}
</script>

<style lang="scss" scoped>
.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.btn {
  i {
    font-size: 25px;
  }

  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}
</style>